import type Sizes from "../types/Sizes";

const getIconSize = (size?: Sizes): string => {
  if (size === "xs") {
    return "text-base";
  }
  return "text-2xl";
};

export default getIconSize;
